import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Popup } from '@store/models';
import { NotificationsSelectors, NotificationsDispatchers } from '../../../store';

@Component({
    selector: 'app-popups',
    template: `
        <app-popups-ui
            [popups]="popups$ | async"
            (updateSeen)="updateSeen($event)"
            (dismiss)="dismiss()"
        ></app-popups-ui>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PopupsContainer implements OnInit {

    popups$ = this.notificationsSelectors.popups$;

    constructor(
        public activeModal: NgbActiveModal,
        public notificationsSelectors: NotificationsSelectors,
        public notificationsDispatchers: NotificationsDispatchers
    ) {}

    ngOnInit() {
        this.notificationsDispatchers.loadPopups();
    }

    updateSeen(popup: Popup) {
        this.notificationsDispatchers.updatePopups(popup);
    }

    dismiss() {
        this.activeModal.dismiss();
    }

}
